import React from 'react'
import { StaticQuery, graphql } from 'gatsby'

import DocumentLink from './documentLink'

export default ({ category }) => (
  <StaticQuery
    query={graphql`
      query {
        allMarkdownRemark(sort: { order: ASC, fields: [frontmatter___date] }) {
          edges {
            node {
              id
              excerpt(pruneLength: 250)
              frontmatter {
                date(formatString: "MMMM DD, YYYY")
                path
                title
                category
              }
            }
          }
        }
      }
    `}
    render={function (data) {
      const Reports = data.allMarkdownRemark.edges
        .filter(edge => edge.node.frontmatter.category === category)
        .map(function (edge) {
          return <DocumentLink key={edge.node.id} post={edge.node} />
        })

      if (category === 'documentation') {
        const docs = [{
          node: {
            frontmatter: {
              path: '/static/dokumentacia_TP_ZS.pdf',
              title: 'Dokumentácia ZS',
              date: 'December 14, 2018',
            },
          },
        },
        {
          node: {
            frontmatter: {
              path: '/static/IIT.SRC.pdf',
              title: 'IIT.SRC',
              date: 'Apil 17, 2019',
            },
          },
        },
        {
          node: {
            frontmatter: {
              path: '/static/Robime.it.pdf',
              title: 'Robime IT',
              date: 'May 10, 2018',
            },
          },
        },
        {
          node: {
            frontmatter: {
              path: '/static/dokumentacia_TP_LS.pdf',
              title: 'Dokumentácia LS',
              date: 'May 10, 2018',
            },
          },
        },
        ]

        docs.forEach((doc, index) => {
          Reports[index] = <DocumentLink key={index} post={doc.node} />
        });
      }

      return <div>{Reports}</div>
    }}
  />
)
